import React from 'react'
import {
    Header,
    Button,
    Icon
} from 'semantic-ui-react'
import PropTypes from 'prop-types'
import './CustomDropdown.scss'
const customDropdown = (props) => {
    return (
      <React.Fragment>
        <div className='custom-dropdown'>
          <Header as='h2' className='custom-dropdown-header'>{props.title}</Header>
          <Button
            icon
            size='massive'
            attached='false'
            onClick={() => props.changeActive(!props.active)}
            style={{
                backgroundColor: props.active && 'rgba(49, 49, 49, 1)'
            }}
            >
            {props.active
            ? <Icon name='chevron up' style={{ color: 'white' }} />
            : <Icon name='chevron down' style={{ color: 'white' }} />}
          </Button>
        </div>
        {props.active && <p style={{ padding: 5 }}>{props.children}</p>}
      </React.Fragment>
    )
}
customDropdown.propTypes = {
    active: PropTypes.bool,
    children: PropTypes.any,
    changeActive: PropTypes.func,
    title: PropTypes.string
  }
export default customDropdown



// WEBPACK FOOTER //
// ./src/components/CustomDropdown/CustomDropdown.js